// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__hIGwq","label":"Section_label__2FO_K","contentWrap":"Section_contentWrap__3xhVG","footer":"Section_footer__3ugMb","footerInner":"Section_footerInner__3ugx4"};